var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAltersverifizierungIdShot = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 133,
    viewBox: "0 0 226 133",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_707_7610",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 226,
    height: 133
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M221.531 0H4C1.79086 0 0 1.79086 0 4V128.8C0 131.009 1.79086 132.8 4 132.8H221.531C223.74 132.8 225.531 131.009 225.531 128.8V4C225.531 1.79086 223.74 0 221.531 0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_707_7610)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9124 124.702L66.9139 148.976C58.3374 150.831 54.0491 149.306 54.0491 144.4C54.0491 139.494 57.0491 126.828 63.0491 106.4L83.928 111.426L77.9124 124.702Z",
    fill: "#F5F6F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.768 57.093C150.768 75.2712 133.96 72.5217 113.225 72.5217C92.4909 72.5217 75.6823 75.2712 75.6823 57.093C75.6823 38.9149 83.8929 6.69275 113.225 6.69275C143.568 6.69275 150.768 38.9149 150.768 57.093Z",
    fill: "#687289"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.114 120.798L171.482 129.349V188.302C171.487 190.908 170.813 193.471 169.525 195.737L155.78 171.639L150.827 121.17L149.594 108.565L168.219 108.958L170.114 120.798Z",
    fill: "#F5F6F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M171.482 118.722C170.821 116.574 169.7 112.944 168.415 108.896C166.153 101.765 163.385 93.3224 161.743 89.3C158.609 81.6217 142.638 84.6992 142.638 84.6992L87.9194 82.6493C87.9194 82.6493 85.8798 82.3808 76.704 81.1622C72.8572 80.651 69.506 86.0417 66.9139 92.4808L61.0491 110.4L79.6628 113.719C78.6374 117.295 78.0496 120.983 77.9123 124.702C77.7677 129.788 78.6662 135.473 82.5441 139C90.9039 146.621 93.5942 180.928 93.5942 180.928L87.7128 203.4H156.384C160.388 203.4 164.229 201.81 167.06 198.978C169.892 196.147 171.482 192.306 171.482 188.302V179.978C167.15 172.966 163.592 169.439 163.592 169.439L151.308 121.123L170.114 120.798L171.482 120.772V118.722Z",
    fill: "#D8DAE0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M132.741 63.2535C142.607 53.3877 142.607 37.3921 132.741 27.5263C122.875 17.6605 106.88 17.6605 97.014 27.5263C87.1482 37.3921 87.1482 53.3877 97.014 63.2535C106.88 73.1192 122.875 73.1192 132.741 63.2535Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9109 44.7501H93.9029L98.311 32.4071L99.1924 44.7501H103.968L106.54 37.55L107.054 44.7501H142.54C142.54 29.9803 130.567 18.0071 115.797 18.0071H110.654C95.8842 18.0071 83.9109 29.9803 83.9109 44.7501Z",
    fill: "#687289"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.632 90.1531H176.899C179.108 90.1531 180.899 91.9439 180.899 94.1531V115.163C180.899 117.372 179.108 119.163 176.899 119.163H135.632C133.423 119.163 131.632 117.372 131.632 115.163V94.1531C131.632 91.9439 133.423 90.1531 135.632 90.1531Z",
    fill: "#43506C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_707_7610",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 134,
    y: 96,
    width: 17,
    height: 17
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.619 112.786C147.039 112.786 150.622 109.203 150.622 104.783C150.622 100.363 147.039 96.7803 142.619 96.7803C138.2 96.7803 134.617 100.363 134.617 104.783C134.617 109.203 138.2 112.786 142.619 112.786Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_707_7610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.619 112.786C147.039 112.786 150.622 109.203 150.622 104.783C150.622 100.363 147.039 96.7803 142.619 96.7803C138.2 96.7803 134.617 100.363 134.617 104.783C134.617 109.203 138.2 112.786 142.619 112.786Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.619 106.554C144.622 106.554 146.245 104.931 146.245 102.928C146.245 100.925 144.622 99.3019 142.619 99.3019C140.617 99.3019 138.993 100.925 138.993 102.928C138.993 104.931 140.617 106.554 142.619 106.554Z",
    fill: "#061437",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.619 119.94C146.124 119.94 148.965 117.098 148.965 113.594C148.965 110.089 146.124 107.248 142.619 107.248C139.115 107.248 136.273 110.089 136.273 113.594C136.273 117.098 139.115 119.94 142.619 119.94Z",
    fill: "#061437",
    fillOpacity: 0.6
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M172.021 95.6549H156.015C155.394 95.6549 154.89 96.1588 154.89 96.7803C154.89 97.4018 155.394 97.9056 156.015 97.9056H172.021C172.642 97.9056 173.146 97.4018 173.146 96.7803C173.146 96.1588 172.642 95.6549 172.021 95.6549Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M162.934 107.802H155.533C155.178 107.802 154.89 108.09 154.89 108.445C154.89 108.8 155.178 109.088 155.533 109.088H162.934C163.289 109.088 163.577 108.8 163.577 108.445C163.577 108.09 163.289 107.802 162.934 107.802Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M174.862 107.802H167.462C167.107 107.802 166.819 108.09 166.819 108.445C166.819 108.8 167.107 109.088 167.462 109.088H174.862C175.218 109.088 175.506 108.8 175.506 108.445C175.506 108.09 175.218 107.802 174.862 107.802Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.229969,
    d: "M176.522 99.9062H156.015C155.394 99.9062 154.89 100.41 154.89 101.032C154.89 101.653 155.394 102.157 156.015 102.157H176.522C177.144 102.157 177.648 101.653 177.648 101.032C177.648 100.41 177.144 99.9062 176.522 99.9062Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.229969,
    d: "M165.076 110.231H155.533C155.178 110.231 154.89 110.519 154.89 110.874C154.89 111.229 155.178 111.517 155.533 111.517H165.076C165.431 111.517 165.719 111.229 165.719 110.874C165.719 110.519 165.431 110.231 165.076 110.231Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.229969,
    d: "M177.004 110.231H167.462C167.107 110.231 166.819 110.519 166.819 110.874C166.819 111.229 167.107 111.517 167.462 111.517H177.004C177.36 111.517 177.648 111.229 177.648 110.874C177.648 110.519 177.36 110.231 177.004 110.231Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAltersverifizierungIdShot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/altersverifizierung-id-shot.e6caa2ada2093bc04987421d0dba12e1.svg";